import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function NurseMenu(){

const MenuCard = ({link,title,icon,color}) => (

<div className="col-xl-3 col-lg-4 col-md-6 mb-4">

<Link to={link} className="menu-link">

<div className="menu-card" style={{borderTop:`4px solid ${color}`}}>

<div className="menu-icon" style={{color:color}}>
<FontAwesomeIcon icon={icon} size="2x"/>
</div>

<p className="menu-title">{title}</p>

</div>

</Link>

</div>

);

return(

<section className="container-fluid mt-4">

<h5 className="menu-section-title">Nursing Panel</h5>

<div className="row">

<MenuCard link="/nurse-view-list" title="Inpatients" icon="fa-solid fa-bed" color="#0d6efd"/>

<MenuCard link="/ot-drug-list?type=ot" title="OT Billing" icon="fa-solid fa-syringe" color="#20c997"/>

<MenuCard link="/raise-indent" title="Raise Indent" icon="fa-solid fa-box-open" color="#6f42c1"/>

<MenuCard link="/vitals-view" title="OP Vitals" icon="fa-solid fa-heart-pulse" color="#dc3545"/>

<MenuCard link="/op-dep" title="OP Appointment" icon="fa-solid fa-calendar-check" color="#fd7e14"/>

</div>

</section>

)

}

export default NurseMenu;